"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    shopConfig: 'Webbshop Konfiguration' || 'shopConfig',
    resolveConfigForSubdomain: 'Hämta whitelabel config' || 'resolveConfigForSubdomain',
    writeShopConfig: 'Uppdatera webbsida' || 'writeShopConfig',
    writeNavbarConfig: 'Uppdatera navbar konfiguration' || 'writeNavbarConfig',
    changeLandingPage: 'Ändra landningssida' || 'changeLandingPage',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    subdomain: 'Subdomän' || 'subdomain',
    logo: 'Logotype' || 'logo',
    favicon: 'Favicon' || 'favicon',
    description: 'Beskrivning i sökresultat' || 'description',
    googleAnalyticsKey: 'Google Analytics Nyckel' || 'googleAnalyticsKey',
    clarityKey: 'Clarity Nyckel' || 'clarityKey',
    emailFooterImage: 'Bild i mailfot' || 'emailFooterImage',
    address: 'Adress' || 'address',
    zipCode: 'Postnummer' || 'zipCode',
    city: 'Stad' || 'city',
    country: 'Land' || 'country',
    aboutUs: 'Om oss länk' || 'aboutUs',
    homePage: 'Hemsida länk' || 'homePage',
    instagram: 'Instagram Länk' || 'instagram',
    facebook: 'Facebook länk' || 'facebook',
    youtube: 'Youtube länk' || 'youtube',
    linkedin: 'Linkedin link' || 'linkedin',
    contactEmail: 'E-post för frågor' || 'contactEmail',
    contactPhone: 'Telefonnummer för frågor' || 'contactPhone',
    companyName: 'Företagsnamn' || 'companyName',
    organization: 'Organisation' || 'organization',
    active: 'Aktiverad' || 'active',
    isSellingAlcohol: 'Säljer alkoholhaltiga produkter' || 'isSellingAlcohol',
    usesSupplierCustomer: 'Använder leverantörskunder' || 'usesSupplierCustomer',
    usesOrganizationProductCategories: 'Använder organisations produktkategorier' ||
        'usesOrganizationProductCategories',
    baseUrl: 'Shopaddress - t.ex. omnipollo.flaivymarket.com, alt. privab.se' ||
        'baseUrl',
    articleFilterPanelConfig: 'Artikelfilterpanel konfiguration' || 'articleFilterPanelConfig',
    navbarConfig: 'Navbar konfiguration' || 'navbarConfig',
    cartProgressBarsColors: 'Färg på kundvagnsprogression' || 'cartProgressBarsColors',
    chatConfig: 'Chat konfiguration' || 'chatConfig',
    theme: 'Tema' || 'theme',
    themes: {
        flaivyVarkalaTheme: 'Flaivy - Varkala' || 'flaivyVarkalaTheme',
        privabTheme: 'Privab' || 'privabTheme',
    },
    hasShopSpecificOrderRequirements: 'Shoppen har egna orderkrav' || 'hasShopSpecificOrderRequirements',
    isPossibleToPlaceOrderBelowOrderMinimum: 'Det är möjligt att lägga order under kollikrav eller minsta ordervärde mot en ev.avgift.' ||
        'isPossibleToPlaceOrderBelowOrderMinimum',
    minOrderValueByRegion: 'Minsta ordervärde regionsvis' || 'minOrderValueByRegion',
    minCollisOnOrderByRegion: 'Minsta antal kollin på order regionsvis' || 'minCollisOnOrderByRegion',
    kegCountsAsNCollis: 'Hur många kollin varje fat räknas som på en order' || 'kegCountsAsNCollis',
    files: {
        id: 'Identitet' || 'id',
        name: 'Filnamn' || 'name',
        file: 'Fil' || 'file',
    },
    pages: {
        id: 'Identitet' || 'id',
        name: 'Sidnamn' || 'name',
        type: 'Sidtyp' || 'type',
        types: {
            landingPage: 'Landningssida' || 'landingPage',
            campaignPage: 'Kampanjsida' || 'campaignPage',
            infoPage: 'Infosida' || 'infoPage',
            hiddenPage: 'Dold sida' || 'hiddenPage',
        },
        description: 'Beskrivning i sökresultat' || 'description',
        title: 'Title - visas i flik och på google' || 'title',
        sortOrder: 'Sidlist ordning' || 'sortOrder',
        layout: 'Sidinnehåll' || 'layout',
    },
};
